import React from "react";
import { Page, Text, View, Document, StyleSheet, Font, Link, Image } from "@react-pdf/renderer";

import logo from "app/assets/logo_virtual_1.png"
import { VatHeder, VatNotes, VatInstalacja, RezerwacjaPobyt } from "../../api";
import { kwotaSlownie, dwaMiejscaPoPrzecinku, oddzielTysiace  } from "../common/helpers";
import CONFIG from "../../cfg/config";



// Register Font
Font.register({
    family: 'Roboto',
    format: "truetype",
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/roboto-font@0.1.0/fonts/Roboto/roboto-regular-webfont.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/roboto-font@0.1.0/fonts/Roboto/roboto-bold-webfont.ttf', fontStyle: 'bold' },
    ]
});

// Register Font
// Font.register({
//     family: 'Arial',
//     format: "truetype",
//     fonts: [
//         { src: 'fonts/ARIAL.TTF' },
//         { src: 'fonts/ARIALBD.TTF', fontStyle: 'bold' },
//     ]
// });

//PM 2021-08-09
interface ContainerPdfProps {
    tytul: string,
    koniecWydrukuOpis: string,

    daneGorne: VatHeder,
    fakturaNotes: VatNotes[],
    fakturaSprzedawca: VatInstalacja,
    logo: string,
    rezerwacja: RezerwacjaPobyt
}

class ContainerPdf extends React.Component<ContainerPdfProps, any> {

    dateTable = (textLeft: string, textRight: string) => {

        return (
            <View style={{...styles.table, justifyContent: "flex-end" }}>
                <View
                    style={{
                        ...styles.tableRowContent,
                    }}
                >
                    <View style={{width: 60 + '%'}}>
                        <Text style={{ ...styles.tableCellLeft, textAlign: "right",}}>
                            {textLeft}
                        </Text>
                    </View>
                    <View style={{width: 40 + '%', paddingLeft: 8}}>
                        <Text style={{ ...styles.tableCellRight, fontStyle: "bold"}}>
                            {"   " + textRight}
                        </Text>
                    </View>
                </View>
            </View>
        )
    }

    textTable = (textLeft: string, textRight: string, leftBold: boolean = false, rightBold: boolean = false) => {
        let dlugosc = 14

        return (
            <View style={styles.containerTopSecondary}>
                <View style={styles.table}>
                    <View
                        style={{
                            ...styles.tableRowContent,
                        }}
                    >
                        <View style={{ width: dlugosc + '%' }}>
                            <Text style={{ ...styles.tableCellLeft, fontStyle: leftBold ? "bold" : "normal" }}>
                                {textLeft}
                            </Text>
                        </View>
                        <View style={{ width: 100 - dlugosc + '%' }}>
                            <Text style={{ ...styles.tableCellRight, fontStyle: rightBold ? "bold" : "normal" }}>
                                {textRight}
                            </Text>
                        </View>
                    </View>
                </View>
            </View>
        )
    }

    //PM 2021-08-10
    public render() {
        let dlugosc =  14 
        let notes = this.props.fakturaNotes.map(x => x.tekst).join("\n")

        let link = `${window.location.href}/${this.props.rezerwacja.pobyt_id}/${this.props.rezerwacja.gosc_telefon}`

        return (
            <Document>
                <Page style={styles.body}>

                    {this.props.logo ?
                     <View style={{...styles.containerTitle}}>
                         <Image src={this.props.logo} style={styles.logo}></Image>  
                    </View> : null}

                    <View style={{...styles.containerTitle, marginTop: 5}}>
                        <Text style={styles.title}>{this.props.tytul}</Text>
                    </View>

                    <View style={{...styles.containerTop, marginTop: 20}} >
                        <View style={styles.topLeft}>
                            <Text style={{...styles.bold,}}>{"SPRZEDAWCA"}</Text>
                        </View>
                        <View style={styles.topRight}>
                            {/* <Text style={styles.topRightText}>{"Data wystawienia 2022-02-02"}</Text> */}
                            {this.dateTable("Data wystawienia", this.props.daneGorne.dataWyst)}
                        </View>
                    </View>
                    {/* <View style={styles.containerTop}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.bold, ...styles.textPaddingLeft }}>{"SPRZEDAWCA: HOTEL POLSKI SP.Z O.O. *** NIP-817-00-08-387"}</Text>
                        </View>
                        <View style={styles.topRight}>
                            <Text style={styles.topRightText}>{"Data sprzedaży/zal 2022-luty"}</Text>
                        </View>
                    </View> */}

                    <View style={styles.containerTop}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.bold, ...styles.textPaddingLeft }}>{this.props.fakturaSprzedawca.naglLinia1}</Text>
                        </View>
                        <View style={styles.topRight}>
                            {this.dateTable("Data sprzedaży/zal", this.props.daneGorne.dataSprz)}
                        </View>
                    </View>
                    <View style={styles.containerTop}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.bold, ...styles.textPaddingLeft }}>{this.props.fakturaSprzedawca.naglLinia2}</Text>
                        </View>
                        <View style={styles.topRight}>
                            {/* <Text style={styles.topRightText}>{"Termin zapłaty 2022-02-02"}</Text> */}
                            {this.dateTable("Termin zapłaty", this.props.daneGorne.terminDt)}
                        </View>
                    </View>
                    {this.props.fakturaSprzedawca.naglLinia3 ?
                        <View style={styles.containerTop}>
                            <View style={styles.topLeft}>
                                <Text style={{ ...styles.bold, ...styles.textPaddingLeft }}>{this.props.fakturaSprzedawca.naglLinia3}</Text>
                            </View>
                        </View>
                    : null}
                    {this.props.fakturaSprzedawca.naglLinia4 ?
                        <View style={styles.containerTop}>
                            <View style={styles.topLeft}>
                                <Text style={{ ...styles.bold, ...styles.textPaddingLeft }}>{this.props.fakturaSprzedawca.naglLinia4}</Text>
                            </View>
                        </View>
                    : null}
                    {this.props.fakturaSprzedawca.naglLinia5 ?
                        <View style={styles.containerTop}>
                            <View style={styles.topLeft}>
                                <Text style={{ ...styles.bold, ...styles.textPaddingLeft }}>{this.props.fakturaSprzedawca.naglLinia5}</Text>
                            </View>
                        </View>
                    : null}
                   
                   

                    {/* <View style={styles.containerTop} fixed>
                        <View style={styles.topLeft}>
                            <Text>{this.props.nazwaFirmyOpis}</Text>
                        </View>
                        <View style={styles.topRight}>
                            <Text style={styles.topRightText}>{this.props.dataOpis}</Text>
                        </View>
                    </View> */}


                    <View style={{...styles.containerTopSecondary, marginTop: 10}}>
                        <Text style={{...styles.titleSecondary, ...styles.bold,}}>{"NABYWCA"}</Text>
                    </View>
                    {this.props.daneGorne.kontrNazwa ?
                        <View style={styles.containerTopSecondary}>
                            <View style={styles.topLeft}>
                                <Text style={{...styles.bold, ...styles.textPaddingLeft }} >{this.props.daneGorne.kontrNazwa}</Text>
                            </View>
                        </View>
                    : null}
                    {this.props.daneGorne.adres ?
                        <View style={styles.containerTopSecondary}>
                            <View style={styles.topLeft}>
                                <Text style={{ ...styles.bold, ...styles.textPaddingLeft }} >{this.props.daneGorne.adres}</Text>
                            </View>
                        </View>
                    : null }
                    {/* {this.textTable(miasto, ulica, true, true)} */}
                    {/* {this.textTable(this.props.daneGorne.adres, "", true, true)} */}

                    {/* <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={styles.textPaddingLeft}>{miasto}<Text style={{paddingLeft: 30}}>{"UL.DUŃSKA 3"}</Text></Text>
                        </View>
                    </View> */}
                    {/* <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.textPaddingLeft}}><Text >{"NIP"}</Text><Text style={{...styles.bold}}>{"   8171885452"}</Text></Text>
                        </View>
                    </View> */}
                    <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.textPaddingLeft,}}>{"NIP"}<Text style={{...styles.bold}}>{"  " + this.props.daneGorne.nip + "  " + this.props.daneGorne.infoF}</Text></Text>
                        </View>
                    </View>
                   
                    


                    <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={{...styles.textPaddingTop, paddingTop: 10, ...styles.bold}}>{"WARTOŚĆ"}</Text>
                        </View>
                    </View>

                    {/* <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={styles.textPaddingLeft}>{"Wartość w PLN 307,65"}</Text>
                        </View>
                    </View> */}
                     {this.textTable("Wartość w PLN", oddzielTysiace(dwaMiejscaPoPrzecinku(this.props.daneGorne.brutto)), false, true)}


                    {/* <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={styles.textPaddingLeft}>{"Sposób zapłaty CardPoint S.A."}</Text>
                        </View>
                    </View> */}
                    {this.textTable("Sposób zapłaty", this.props.daneGorne.lookUpSpZaplatyOpis, false, true)}

                

                    {/* 
                    <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={styles.textPaddingLeft}>{"Słownie pln *trzy*zero*siedem*.*sześć*pięć*"}</Text>
                        </View>
                    </View> */}
                    {this.textTable("Słownie pln", kwotaSlownie(this.props.daneGorne.brutto))}

                    <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={{paddingTop: 10, ...styles.bold,}}>{"INNE"}</Text>
                        </View>
                    </View>
                    {/* <View style={styles.containerTopSecondary}>
                        <View style={styles.topLeft}>
                            <Text style={styles.textPaddingLeft}>{"Pokój nr 315 Pobyt od-do 2022-02-01 2022-02-02 "}</Text>
                        </View>
                    </View> */}
                    {/* {this.textTable("Pokój nr 315", "Pobyt od-do 2022-02-01 / 2022-02-02")} */}

                    <View style={styles.table}>
                        <View
                            style={{
                                ...styles.tableRowContent,
                            }}
                        >
                            <View style={{ width: dlugosc + '%' }}>
                                <Text style={{ ...styles.tableCellLeft }}>
                                    {"Pokój nr   "}
                                    <Text style={{ fontStyle: "bold" }}>{this.props.daneGorne.pokoj}</Text>
                                </Text>
                            </View>
                            <View style={{ width: 100 - dlugosc + '%' }}>
                                <Text style={{ ...styles.tableCellRight }}>
                                    {"Pobyt od-do   "}
                                    <Text style={{ fontStyle: "bold" }}>{this.props.daneGorne.pobytOd + " / " + this.props.daneGorne.pobytDo}</Text>
                                </Text>
                            </View>
                        </View>
                    </View>


                    <View style={styles.containerTopSecondary}>
                        <View style={{paddingBottom: "10px"}}> 
                        </View>
                    </View>



                    {this.props.children}



                    <View wrap={false} style={styles.containerTopSecondary}>
                        <Text style={{...styles.titleSecondary, lineHeight: "1.5px"}}>{notes}</Text>
                    </View>


                    <View wrap={false} style={{...styles.containerMiddle, marginTop: 50}} >
                        
                        <View style={styles.middleLeft}>
                            <Text>{this.props.daneGorne.osobaOdb}</Text>
                        </View>
                        <View style={{...styles.middleMiddle}}></View>
                        <View style={styles.middleRight}>
                            <Text>{this.props.daneGorne.lookUpOperatorOpis}</Text>
                        </View>
                    </View>
                    <View style={styles.containerMiddle} >
                        <View style={{...styles.middleLeft, borderTop: "1px solid black"}}></View>
                        <View style={{...styles.middleMiddle}}></View>
                        <View  style={{...styles.middleRight, borderTop: "1px solid black"}}></View>
                    </View>
                    <View style={styles.containerMiddle} >
                        <View style={styles.middleLeft}>
                            <Text>{"Odbiorca"}</Text>
                        </View>
                        <View style={{...styles.middleMiddle}}></View>
                        <View style={styles.middleRight}>
                            <Text >{"Wystawił"}</Text>
                        </View>
                    </View>

                    {/* <View wrap={false}>
                        <View style={{ ...styles.containerTitle, marginTop: 20 }}>
                            <Text style={styles.text}>{'DZIĘKUJEMY_ZA_REZERWACJE_i_ZAPRASZAMY_DO_NAS...DZIĘKUJEMY_ZA_REZERWACJE_i_ZAPRASZAMY_DO_NAS...'}</Text>
                        </View>

                        <View style={{ ...styles.containerTitle, marginTop: 15 }}>
                            <Text style={styles.text}>{'UWAGA ZMIANA NUMERU RACHUNKU BANKOWEGO'}</Text>
                        </View>
                    </View> */}



                    {/* <View style={styles.containerBottom}>
                        <Text style={styles.bottomLeftText} render={({ totalPages }) => (
                            `${this.props.koniecWydrukuOpis}. Liczba stron ${totalPages}.`
                        )} fixed />
                        <Text style={styles.bottomRightText}><Link src="http://www.virtualsc.com.pl/">www.virtualsc.com.pl</Link></Text>
                    </View> */}

                    {/*{`${this.props.koniecWydrukuOpis}. Liczba stron ${totalPages}.     ` }
                                <Link style={styles.link} src={link}>{link}</Link>*/}
                    <Text style={styles.footerLeft} render={({ totalPages }) => (
                         (
                            <Text style={styles.footerLeftText}>                              
                                {`Od dnia 2026-04-01 Faktury dla firm wysylamy do KSeF w ciagu 24 godzin od daty wystawienia Specyfikacji.` }
                            </Text>
                            )
                    )}/>

                    {/*`strona ${pageNumber}/${totalPages}`*/}
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                        `${this.props.daneGorne.dokTypNrWydruk} str. ${pageNumber}/${totalPages}`
                    )} fixed />
                </Page>
            </Document>
        )
    };
}

const FONT_FAMILY = 'Roboto';
const styles = StyleSheet.create({
    body: {
        flex: 1,
        padding: "30px 30px 40px",
        //paddingBottom: 65,
        fontFamily: "Roboto",
    },
    containerTop: {
        flexDirection: "row" as "row",
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 8,
        //color: 'grey',
        //lineHeight: "1.5px"
    },
    containerTopSecondary: {
        flexDirection: "row" as "row",
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 8,
        //color: 'grey',
        //lineHeight: "1.5px"
    },
    containerBottom: {
        flexDirection: "row" as "row",
        marginTop: 20,
        fontSize: 7,
        color: 'grey',
    },
    containerMiddle: {
        flexDirection: "row" as "row",
        fontSize: 7,
    },
    containerTitle: {
        flexDirection: "row" as "row",
        justifyContent: "center",
    },
    title: {
        fontSize: 15,
        fontStyle: 'bold'
        // color: '#458B00',
    },
    titleSecondary: {
        padding: 0,
        marginBottom: 0,
        marginTop: 0,
    },
    bottomLeftText: {
        flex: 1,
        textAlign: 'left',
    },
    bottomRightText: {
        flex: 1,
        textAlign: 'right',
        textDecoration: 'none'
    },
    topLeft: {
        flex: 1
    },
    topRight: {
        flex: 0, 
        minWidth: "30%",
        width: "30%"
    },
    middleLeft: {
        fontSize: 7,
        width: "50%"
    },
    middleMiddle: {
        width: "20%"
    },
    middleRight: {
        fontSize: 7,
        width: "30%",
        textAlign: 'right',
    },
    topRightText: {
        textAlign: 'right',
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 7,
        bottom: 30,
        left: 0,
        right: 0,
        paddingRight: 30,
        textAlign: 'right',
        //color: 'grey',
    },

    footerLeft: {
        position: 'absolute',
        fontSize: 7,
        bottom: 30,
        left: 0,
        right: 0,
        paddingLeft: 30,
        //textAlign: 'right',
        //color: 'grey',
    },
    footerLeftText: {
        fontSize: 7,
        //color: 'grey',
    },
    link: {
        fontSize: 7,
        color: 'blue',
        textDecoration: 'underline',
    },
    logo: {
       width: "150px",
       height: "60px",
       marginBottom: "10px"
    },
    textPaddingLeft: {
        paddingLeft: 5
    },
    textPaddingTop: {
        paddingTop: 5
    },
    bold: {
        fontStyle: 'bold'
    },
    text: {
        fontSize: 8,
    },

    table: {
        width: "auto",
        borderWidth: 0,
    },
    tableRowContent: {
        //margin: " 0 0 0 auto",
        flexDirection: "row",
        //borderStyle: BORDER_STYLE,
        //borderColor: BORDER_COLOR,
        //paddingTop: 2,
        //paddingBottom: 2
    },
    tableCellLeft: {
        fontSize: 8,
        //textAlign: 'left',
        marginLeft: '6px',
    },
    tableCellRight: {
        fontSize: 8,
        //textAlign: 'left',
        //marginLeft: '15px',
    },
});

export default ContainerPdf;
